/** Only show a preference the customer actually selected. */
export function contactPreferenceLabel(value: unknown): string | undefined {
  if (value === 'email') return 'Email';
  if (value === 'phone') return 'Phone';
  if (value === 'both') return 'Email and phone';
  return undefined;
}
